import ProductDescription from './ProductDescription'

const EggsProduct = {
  ...ProductDescription,
  category: '03',
  subCategory: '005',
  IsBroadband: true,
  Grade: '',
  ContainerSize: 'One dozen only',
}

export default EggsProduct
